"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Paragraph = _typography.default.Paragraph,
  Text = _typography.default.Text;
var SuccessMessage = function SuccessMessage(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "success-message"
  }, /*#__PURE__*/_react.default.createElement(Paragraph, null, "Group ", /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, name), " successfully created"));
};
var _default = SuccessMessage;
exports.default = _default;